// import jsonHelper from "../../shared/jsonHelper";

export default {
  state: {
    isSidebarHidden: false,
    isAsideMenuHidden: true
  },
  getters: {
    sidebar: state => state.isSidebarHidden,
    asideMenu: state => state.isAsideMenuHidden
  },
  mutations: {
    toggleSidebarHiddenProp(state) {
      state.isSidebarHidden = !state.isSidebarHidden;
    },
    toggleAsideMenuHiddenProp(state) {
      state.isAsideMenuHidden = !state.isAsideMenuHidden;
    }
  },
  actions: {
    toggleSidebarProperty({ commit }) {
      commit("toggleSidebarHiddenProp");
    },
    toggleAsideMenuProperty({ commit }) {
      commit("toggleAsideMenuHiddenProp");
    }
  }
};
